<div class="h-0 invisible">
  <input #UploadFileInput type="file" (change)="onUploadQuery($event.target)" />
  <a id="downloadAnchorElem" style="display: none"></a>
</div>

<div class="flex flex-row justify-between p-4">
  <div class="basis-[59%] border scrollable-container">
    <app-search-query-form
      [form]="form"
      (uploadQuery)="uploadQuery()"
      (downloadQuery)="downloadQuery()"
    ></app-search-query-form>
  </div>

  <div class="basis-[39%] border scrollable-container">
    @if (searchQuery$ | async; as searchQuery) {
      <div class="p-4">
        <mat-tab-group #tabs>
          <mat-tab label="Query">
            <ng-container [ngTemplateOutlet]="QueryTab" [ngTemplateOutletContext]="{ searchQuery }"> </ng-container>
          </mat-tab>
          <mat-tab label="Preview" [disabled]="!sampleExperts">
            <ng-container [ngTemplateOutlet]="PreviewTab" [ngTemplateOutletContext]="{ searchQuery }"> </ng-container>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
  </div>
</div>

<ng-template #QueryTab let-searchQuery="searchQuery">
  <div class="flex flex-col gap-4 pt-4">
    <div class="flex flex-row justify-end items-center">
      <button class="button button--primary" data-test-id="search-layout-run-query" (click)="runQuery(searchQuery)">
        @if (!sampleLoading) {
          Run query
        } @else {
          <app-spinner size="sm" />
        }
      </button>
    </div>

    @if (queryStats$ | async; as queryStats) {
      <div>
        @if ('error' in queryStats) {
          <p class="text-red-500">
            {{ queryStats.error }}
          </p>
        } @else {
          <ul>
            <li>Profile Count: {{ queryStats.profile_count }}</li>
            <li>High Confidence Email Count: {{ queryStats.high_confidence_email_count }}</li>
            <li>High Confidence Phone Count: {{ queryStats.high_confidence_phone_count }}</li>
            <li>Started Screener Count: {{ queryStats.started_screener_count }}</li>
            <li>Completed Screener Count: {{ queryStats.completed_screener_count }}</li>
            <li>Completed Engagement Count: {{ queryStats.completed_engagement_count }}</li>
          </ul>
        }
      </div>
    }

    @if (searchQuery.validationErrors.length) {
      <div>
        <h3>Query errors</h3>

        <ul class="list-disc">
          @for (item of searchQuery.validationErrors; track item) {
            <li>
              <span class="text-red-500">{{ item }}</span>
            </li>
          }
        </ul>
      </div>
    }

    @if (searchQuery.validationWarnings.length) {
      <div>
        <h3>Query warnings</h3>

        <ul class="list-disc">
          @for (item of searchQuery.validationWarnings; track item) {
            <li>
              <span class="text-orange-500">{{ item }}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</ng-template>

<ng-template #PreviewTab let-searchQuery="searchQuery">
  <app-results-display-beta
    [experts]="sampleExperts ?? []"
    [maskedMode]="maskedMode"
    (onContinue)="submitSearch(searchQuery)"
  ></app-results-display-beta>
</ng-template>
